import React, { useState, useEffect, useRef } from 'react'

import { useDispatch, useSelector, shallowEqual } from 'react-redux'

import {numberWithCommas} from '../../../utils/helpers' 

import { Table, Tooltip,Tag,Form, Input, Button, Space,Modal,Descriptions,Divider,
  Statistic, Col,Popconfirm,Collapse,Select,DatePicker, List,InputNumber,
  TimePicker,Checkbox, message} from 'antd';
import {   
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    UserOutlined,
    VideoCameraOutlined,
    UploadOutlined, 
    DeploymentUnitOutlined,
    SearchOutlined,
    EditOutlined,
    PlusOutlined,
    SaveOutlined,
    ShoppingCartOutlined,
    DeleteOutlined
} from '@ant-design/icons';

import './styles.scss'

import moment from 'moment'
import {getData,editItem,addItem,deleteItem,updateItem} from '../../../Redux/actions/crudActions'
import {setPrice} from '../../../Redux/actions/productActions'
import {addCartItem,getCart,deleteCartItem,editCartItem,clearCart} from '../../../Redux/actions/cartActions'
import {createPackage,getPackageData,setPackage,deletePackagetItem,editPackageItem,attachSource} from '../../../Redux/actions/packageActions'
import {setPurchaseOrder,updatePurchaseOrder,setSalesOrderPO,attachPurchaseItemSource} from '../../../Redux/actions/purchaseActions'

import {errorParser} from '../../../utils/helpers'

import CreateForm from '../../Generic/CreateForm'
import InputSelect from '../../Generic/InputSelect'
import ImageChecker from '../../Generic/ImageChecker'

import parse from 'path-parse';


const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

const Index = ({purchaseItem}) => { 
    
    const dispatch = useDispatch()    
    const { user,cart,crudData} = useSelector(state => ({
      user: state.auth.user,
      cart: state.cart.data,
      crudData: state.packages.data,
    }), shallowEqual)


    const [isModalVisible, setIsModalVisible] = useState(false); 
    const [modalWidth, setmodalWidth] = useState('80%')
    const [loading, setLoading] = useState(false)

    const [somethingChanged, setSomethingChanged] = useState(false)

    const [items, setItems] = useState([])
    const [costTotal, setCostTotal] = useState(0)




    useEffect(() => {
      console.log(purchaseItem)
      if(purchaseItem && purchaseItem !== []){
 

        if(!Array.isArray(purchaseItem)){      
          if(purchaseItem.status == 'toApprove'){
            attachingSource()
          }else{
    
            setItems(purchaseItem.items)
            var costTotalnew = 0 
            purchaseItem.items.map(xitem =>{
              if(parseFloat(xitem.tobuy) > 0){
                costTotalnew = costTotalnew + (parseFloat(xitem.cost_peso_new) * parseFloat(xitem.tobuy))
              }
            })
            setCostTotal(costTotalnew)
          }     
        }
      }

    },[purchaseItem]);

    const attachingSource = async () =>{

      var purchaseItems = await dispatch(attachPurchaseItemSource(purchaseItem.items))
      setIsModalVisible(true)
      var total = 0
      purchaseItems.map(it =>{
     
        total = total + parseFloat(it.tobuy) * parseFloat(it.cost_peso)
      })
      total = total.toFixed(2)
      setItems(purchaseItems)
      setCostTotal(total)
      
    }

  

    return(       
     
      <h2>₱{numberWithCommas(parseFloat(costTotal).toFixed(2))}</h2>
    )
}
  
export default Index
  